import { Component } from '@angular/core';
import { environment } from '../../environments/environment';

@Component({
  selector: 'adminapp-summary-description-dms',
  templateUrl: './summary-description-dms.component.html',
  styleUrls: ['./summary-description-dms.component.scss']
})
export class SummaryDescriptionDMSComponent {

  dmsPortalUrl = null;

  constructor() {
    this.dmsPortalUrl = environment.dmsPortalUrl;
  }
}
